module.exports = __webpack_public_path__ + "img/BAHN1.9020f072.png";